export default __webpack_public_path__ + "static/media/2122 knife block A side.51c8d8a8.png";